import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

interface ClaimsIdentity {
  name: string;
  preferred_username: string;
  family_name: string;
  given_name: string;
}

const isValidIdentity = (identity: object | undefined): identity is ClaimsIdentity => {
  if (identity === undefined) return false;

  const claimsIdentity = identity as ClaimsIdentity;
  return [claimsIdentity.name, claimsIdentity.preferred_username].every((key) => typeof key === "string");
};

const getIdentityFromAccount = (account: AccountInfo | null) =>
  isValidIdentity(account?.idTokenClaims) ? account?.idTokenClaims : undefined;

const useIdentity = () => {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0] ?? null;
  const identity = getIdentityFromAccount(account);

  return {
    id: identity?.oid,
    fullName: identity?.name,
    firstName: identity?.given_name,
    lastName: identity?.family_name,
    email: identity?.preferred_username,
  };
};

export default useIdentity;
